import React, { useEffect } from "react";
import { useSelector } from "react-redux";

import "./MessageLogs.scss";
import ListContainer from "../../modules/messageLog/containers/List";
import MessageLogsTable from "../Table/MessageLogs";
import MessageLogsFilterForm from "../Forms/Filters/MessageLogs";
import withPage from "./withPage";
import { PAGE_SIZE } from "../../constants";
import RoutePlanCurrent from "../RoutePlan/RoutePlanCurrent";
import { getTranslation } from "../../utils/helper";

const MessageLogsPage = ({ isFetching, messageLogs, metadata, query, pushTo, doGetAllMessageLogs }) => {
  const user = useSelector(state => state.auth.user);
  const setting = user.company;

  const currentPage = Number(query.currentPage) || 1;
  const itemsPerPage = Number(query.itemsPerPage) || PAGE_SIZE;
  const pagination = {
    current: currentPage,
    pageSize: itemsPerPage,
    total: metadata.totalItems,
    showTotal: total => `${total} ${getTranslation(setting, "Message Logs", "Message Logs")}`,
  };

  useEffect(() => {
    doGetAllMessageLogs({ currentPage, itemsPerPage, ...query });
  }, []);

  const handleFilter = (params, updatePath) => {
    if (updatePath) {
      pushTo({ query: params });
    }
    const currentPage = Number(params.currentPage) || 1;
    const itemsPerPage = Number(params.itemsPerPage) || PAGE_SIZE;
    doGetAllMessageLogs({
      currentPage,
      itemsPerPage,
      ...params,
    });
  };

  const handleTableChange = params => {
    handleFilter(params, true);
  };

  return (
    <div className="Content MessageLogsPage">
      <RoutePlanCurrent />
      <div className="ContentHeader">
        <div className="HeaderTitle">{getTranslation(setting, "Message Logs", "Message Logs")}</div>
      </div>
      <div className="ContentFilters">
        <MessageLogsFilterForm isFetching={isFetching} query={query} onSubmit={handleFilter} />
      </div>
      <div className="ContentMain">
        <MessageLogsTable
          rowKey="_id"
          loading={isFetching}
          query={query}
          pagination={pagination}
          dataSource={messageLogs.length > 0 ? messageLogs : []}
          onChange2={handleTableChange}
          scrollHeight="calc(100vh - 285px)"
          actionWidth={120}
          setting={setting}
        />
      </div>
    </div>
  );
};

export default withPage(ListContainer(MessageLogsPage));
